import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-80380774")

_pushScopeId("data-v-80380774")
const _hoisted_1 = { class: "vue-flex-row patient-header" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_label_text = _resolveComponent("label-text")
  const _component_ruby_text = _resolveComponent("ruby-text")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_label_text, { label: "患者No." }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.patientDetail?.patient.patientNumber), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_label_text, {
      class: "margin",
      label: "名前"
    }, {
      default: _withId(() => [
        _createVNode(_component_ruby_text, {
          ruby: _ctx.patientDetail?.patient.read
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.patientDetail?.patient.name), 1)
          ]),
          _: 1
        }, 8, ["ruby"])
      ]),
      _: 1
    }),
    _createVNode(_component_label_text, {
      class: "margin",
      label: "性別"
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.patientDetail?.genderString), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_label_text, {
      class: "margin",
      label: "生年月日"
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.patientDetail?.birthDateString) + " (" + _toDisplayString(_ctx.patientDetail?.age) + " 歳) ", 1)
      ]),
      _: 1
    })
  ]))
})